import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';

interface CategoryItem {
  slug: string;
  name: string;
  description: string;
  icon: string;
  count: number;
}

interface CategoryGridProps {
  categories: CategoryItem[];
}

export default function CategoryGrid({ categories }: CategoryGridProps) {
  return (
    <section aria-labelledby="home-columns">
      <SectionHeading
        eyebrow="Six Tracks"
        title="六大内容栏目"
        description="每条栏目对应一类可追查的公开线索，从资金流到人事变动，逐项整理成档。"
      />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((category) => (
          <Link
            key={category.slug}
            to={`/category/${category.slug}`}
            className="group flex h-full flex-col rounded-lg border border-background-300/70 bg-background-100 p-5 transition-colors hover:border-primary-300"
          >
            <div className="flex items-center justify-between">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-lg text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={category.icon} />
              </span>
              <span className="font-label text-xs text-foreground-500">{category.count} 篇档案</span>
            </div>
            <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
              {category.name}
            </h3>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
              {category.description}
            </p>
            <span className="mt-4 inline-flex items-center gap-1 font-label text-sm font-medium text-primary-600">
              进入栏目
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-arrow-right-line" />
              </span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}